import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import {observable, action} from "mobx";
import {observer} from "mobx-react";
import {DialogAncestor} from "core/common/page/dialogAncestor";
import SqlSelectEditor from "core/components/editors/sqlSelectEditor";
import partyService from "party/partyService";
import {IDomainObject} from "core/form/formUtils";
import gridService from "core/grid/gridService";
import GridConfig from "core/grid/domain/gridConfig";
import {GridLocation} from "core/grid/domain/grid";

interface SqlSelectDialogProps {
  title: string;
}

@observer
export default class SqlSelectDialog extends DialogAncestor<SqlSelectDialogProps, undefined, GridConfig> {

  @observable private sqlCommand: string;
  private gridLocation: GridLocation;

  @action open(resolve, reject, sqlCommand, gridLocation: GridLocation) {
    console.log('NoteDialog: Opening dialog');
    this.resolve = resolve;
    this.reject = reject;
    this.$errors = null;
    this.sqlCommand = (sqlCommand == null) ? '' : sqlCommand;
    this.dialogOpen = true;
    this.gridLocation = gridLocation;
  }



  @action ok = () => {
    console.log('SqlSelectDialog OK');

    gridService.getColumnsFromSql(this.sqlCommand, this.gridLocation)
      .then( (gridConfig: GridConfig) => {
        this.dialogOpen = false;
        this.resolve(gridConfig);
      }, error => {
        this.$errors = error.getMessages();
      });
  };


  @action cancel = (evt) => {
    console.log('SqlSelectDialog#cancel evt = %O', evt);
    this.dialogOpen = false;
    this.reject(null);
  };

  @action onChange = (sqlCommand) => {
    this.sqlCommand = sqlCommand;
  };


  render() {
    if (!this.dialogOpen) return null;

    return (
      <Dialog
        actions={[<FlatButton label="Cancel" tabIndex={0} primary onClick={this.cancel}/>,
          <FlatButton label="Ok" disabled={!this.sqlCommand} secondary onClick={this.ok}/>
        ]}
        modal={true}
        title={this.props.title}
        open={this.dialogOpen}
        contentStyle={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', filter: 'blur(0)'}}
        bodyStyle={{overflowY: 'auto'}}
      >

          <ErrorComp messages={this.$errors}/>
          <SqlSelectEditor sqlCommand={this.sqlCommand} onChange={this.onChange} style={{height: 400}}/>

      </Dialog>
    );
  }

}






// WEBPACK FOOTER //
// ./src/core/components/dialogs/sqlSelectDialog.tsx